<script>
export default {
	name: 'CustomCheckbox',
	data() {
		return {
			checked: false
		}
	},
	props: {
		colorBackground: {
			type: String,
			default: 'var(--accent-color)'
		},
		colorTick: {
			type: String,
			default: 'var(--button-login)'
		}
	},
	computed: {
		cssVars() {
			return {
				'--background-color': this.colorBackground,
				'--tick-color': this.colorTick
			}
		}
	}
}

</script>

<template>
	<div class="custom-checkbox" :style="cssVars">
		<input type="checkbox" v-model="checked" id="checkbox" />
		<label for="checkbox">
      <span class="checkbox-box">
        <svg v-if="checked" viewBox="0 0 24 24" class="checkmark" :style="cssVars">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
        </svg>
      </span>
			<span class="checkbox-label">Remember me</span>
		</label>
	</div>
</template>

<style scoped>
.custom-checkbox {
	display: flex;
	align-items: center;
}

.custom-checkbox input[type="checkbox"] {
	display: none;
}

.custom-checkbox label {
	display: flex;
	align-items: center;
	cursor: pointer;
	user-select: none;
	position: relative;
}

.checkbox-box {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	height: 18px;
	border: 2px solid #ccc;
	border-radius: 3px;
	margin-right: 8px;
	background-color: #fff;
	position: relative;
	z-index: 1;
}

.checkbox-box::before {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) scale(0);
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background-color: rgba(0, 0, 0, 0.04);
	transition: transform 0.2s ease-in-out;
	z-index: -1;
}

.custom-checkbox label:hover .checkbox-box::before {
	transform: translate(-50%, -50%) scale(1);
}

.custom-checkbox input[type="checkbox"]:checked + label .checkbox-box {
	background-color: var(--background-color);
	border-color: #4a90e2;
}

.custom-checkbox input[type="checkbox"]:checked + label .checkbox-box::before {
	background-color: rgba(74, 144, 226, 0.1);
}

.checkbox-box::after {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) scale(0);
	width: 36px;
	height: 36px;
	border-radius: 50%;
	z-index: -1;
	opacity: 0;
	transition: transform 0.2s ease-out, opacity 0.2s ease-out;
}

.custom-checkbox input[type="checkbox"]:active + label .checkbox-box::after,
.custom-checkbox label:active .checkbox-box::after {
	transform: translate(-50%, -50%) scale(1);
	opacity: 1;
	transition: transform 0s, opacity 0s;
}

.checkmark {
	width: 14px;
	height: 14px;
	fill: var(--tick-color);
}

.checkbox-label {
	font-size: 14px;
	color: #333;
}
</style>